import { Title } from '@angular/platform-browser';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Examen } from '@shared/forms/templates/exams-config/Examen.config';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AsideService } from '@shared/components/aside/aside.service';
import { MessageAlertService } from '@shared/views/_messagesService/_messageAlertServices';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service';
import { ExamsConfigService } from '@shared/forms/templates/exams-config/exams-config.service';
import { DatabaseService } from '@app/database/database.service';
import moment from 'moment';
import { environment } from '@env/environment';
import { GroupDTemplateService } from '@shared/forms/templates/group-d-template/group-d-template.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { IEspecialidades } from '@app/database/models/IEspecialidades.model';

@Component({
	selector: 'app-group-b-template',
	templateUrl: './group-b-template.component.html',
	styleUrls: ['./group-b-template.component.scss'],
})
export class GroupBTemplateComponent implements OnInit, OnDestroy {
	public currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
	@Input() examen: any; // IExamen;
	submitted = false;
	public examForm: FormGroup;
	seniority = 0;
	unidadTiempo = '';
	maxDate = new Date();
	maxDateIngreso = new Date();
	minDate: any;
	asideObservable: Subscription;
	displayAgentes = false;
	configForm: Examen;
	tiposDictamen: any[] = [];
	especialidades: IEspecialidades[];
	invalidField = false;
	attachedFiles: any = {
		data: [],
		invalid: false,
		isEmpty: true,
		attachedFilesValidQuantity: 0
	};
	enviandose = false;
	isOnline = true;
	isDescripcionLesionesPageBreak = false;
	isRestosPielPageBreak = false;
	displayModalFirma = false;
	medicoFirmaB64;
	medicoFirmaSigString;

	constructor(private titleService: Title,
		private router: Router,
		private groupDTemplateService: GroupDTemplateService,
		private confirmationService: ConfirmationService,
		private asideService: AsideService,
		private messageAlertServices: MessageAlertService,
		private backgroundSyncService: BackgroundSyncService,
		private examConfigService: ExamsConfigService,
		private databaseService: DatabaseService,
		private connectionService: ConnectionService
	) {
	}

	get f(): any {
		return this.examForm.controls;
	}

	ngOnDestroy(): void {
		if (this.asideObservable) {
			this.asideObservable.unsubscribe();
		}
		this.asideService.setInsideExamen(false);
		this.titleService.setTitle('Provincia ART ML Offline');
	}

	ngOnInit(): void {
		this.titleService.setTitle('Provincia ART ML Offline');

		this.connectionService.monitor().subscribe((connected: ConnectionState) => {
			this.isOnline = connected.hasNetworkConnection;
		})
		this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));
		this.cargarFormulario();
		this.calcularAntiguedad();
		this.getTiposDictamen();
		this.getEspecialidades();
		this.minDate = new Date(moment(this.examen.fechaAsignacion).format());
		this.asideObservable = this.asideService.openModalSubject$.subscribe(
			(data) => {
				this.goBack(data);
			}
		);
		this.asideService.setInsideExamen(true);
	}

	cargarFormulario(): void {
		let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
			? this.examen.tipoEstudio.tipoEstudioCod
			: this.examen.tipoEstudio;
		this.configForm = this.examConfigService.getConfig(codigoTipoExamen);
		this.configForm.name = this.examen.provinciaNombreEstudio;
		this.examForm = this.configForm.examForm;
		this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
		this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
		this.calculateAge();
		this.examen.puestoTrabajador ? this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
		this.examen.antiguedadPuestoTrabajador ? this.examForm.controls.antiguedadPuestoTrabajador.setValue(this.standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
		this.examen.fechaIngresoEmpresa ? this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
		this.restrictDateIngresoEmpresa();
		let riesgo = this.examen.esops.map((x) => { return x.descripcion }).join(', ');
		riesgo = (riesgo.length > 250) ? riesgo.substring(0, 249) : riesgo;
		this.examForm.controls.riesgo.setValue(riesgo);
		this.medicoFirmaB64 = this.examen.medicoFirmaB64;
		this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
		if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {
			this.setValuesOnFormOnViewAndEditMode();
		} else {
			this.examen.expAnt = this.examForm.controls.expAnt.value;
			this.examen.elemProt = this.examForm.controls.elemProt.value;
			this.examen.antEnfDer = this.examForm.controls.antEnfDer.value;
			this.examen.lesion = this.examForm.controls.lesion.value;
			this.examen.restNorm = this.examForm.controls.restNorm.value;
			this.examen.restPat = this.examForm.controls.restPat.value;
			this.examen.diagnosticoNormal = this.examForm.controls.diagnosticoNormal.value;
		}
	}

	standarizeDate(date: any) {
		let splitedDate = date.replace(/\//g, '-');
		const dateParts = splitedDate.split('-');
		if (date.includes('/')) {
			return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
		} else {
			return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
		}
	}

	/**
	 * Método que se encarga de obtener los tipos de dictamen
	 */
	async getTiposDictamen(): Promise<void> {
		const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
		this.tiposDictamen = dataFromOffline.filter(
			(x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
		);
	}

	async getEspecialidades(): Promise<void> {
		const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
		this.especialidades = especialidadesListFromOffline;
	}

	private getDescripcionDomicilio(): string {
		return (this.examen.trabajador.calle)
			? `${this.examen.trabajador.calle} ${this.examen.trabajador.numeroCalle ? this.examen.trabajador.numeroCalle : ''}`
			: '';
	}

	/**
	 * Método que se encarga de calcular la antiguedad del trabajador (en meses o años)
	 */
	calcularAntiguedad(): void {
		if (this.examen.fechaAltaEmpleado) {
			this.seniority = moment().diff(
				moment(this.examen.fechaAltaEmpleado),
				'years'
			);
			if (this.seniority > 1) {
				this.unidadTiempo = 'años';
			} else if (this.seniority < 1) {
				this.seniority = moment().diff(
					moment(this.examen.fechaAltaEmpleado),
					'months'
				);
				if (this.seniority > 1) {
					this.unidadTiempo = 'meses';
				} else {
					this.unidadTiempo = 'mes';
				}
			} else {
				this.unidadTiempo = 'año';
			}
		}
	}

	async onSubmit(): Promise<void> {
		this.submitted = true;
		if (this.examForm.invalid || this.invalidField || this.attachedFiles.invalid || this.medicoFirmaB64 == null) {
			this.navigateInvalidField('ng-invalid');
			return;
		}
		this.enviandose = true;
		if (this.isOnline) {
			this.saveToOnline();
		} else {
			this.saveToOffline();
		}
	}

	/**
	 * Método que se encarga
	 * @param ruta
	 */
	goBack(ruta?): void {
		if (this.examForm.dirty) {
			this.confirm(ruta);
		} else {
			this.returnToExams(ruta);
		}
	}

	/**
	 * Método que se encarga de abrir el modal y redirigir a la pagina de la ruta que recibe
	 * @param ruta ruta para redirigir
	 */
	confirm(ruta?): void {
		this.confirmationService.confirm({
			header: `¿Está seguro de que desea cancelar la carga del examen?`,
			message: `Si cancela el examen ahora perderá toda la información cargada hasta el momento`,
			key: 'goBackFormEC',
			accept: () => {
				this.asideService.setInsideExamen(false);
				this.returnToExams(ruta);
			},
		});
	}

	returnToExams(ruta?): void {
		this.router.navigate([ruta ? ruta : 'examenes']);
	}

	buildUrlApi(method: string): string {
		return `${environment.apiUrl}` + method;
	}

	buildRequest(): any {
		let examFormData = { ...this.examForm.getRawValue() };
		examFormData.userId = this.currentUser.userId;
		examFormData.username = this.currentUser.username;
		examFormData.modelId = this.currentUser.modelId;
		examFormData.tipoEstudio = this.configForm.code;
		examFormData.examenNumero = this.examen.id;
		examFormData.fechaRealizacion = moment(examFormData.fechaRealizacion).format(
			'yyyy-MM-DD'
		);
		examFormData.fechaIngresoEmpresa = moment(examFormData.fechaIngresoEmpresa).format(
			'yyyy-MM-DD'
		);
		examFormData.antiguedadPuestoTrabajador = moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD');
		this.examen?.modoVista === "edit" ? examFormData.esEdicion = !!(this.examen?.modoVista === "edit" && this.isOnline) : null;
		examFormData.adjuntos = this.attachedFiles.data;

		examFormData.expAnt = examFormData.expAntSi;
		examFormData.elemProt = examFormData.elemProtSi;
		examFormData.antEnfDer = examFormData.antEnfDerSi;
		examFormData.lesion = examFormData.lesionSi;
		examFormData.diagnosticoNormal = examFormData.diagnosticoNormal ? examFormData.diagnosticoNormal : false;
		examFormData.dermatitisIrritativaContacto = examFormData.dermatitisIrritativaContacto ? examFormData.dermatitisIrritativaContacto : false;
		examFormData.dermatitisAlergicaContacto = examFormData.dermatitisAlergicaContacto ? examFormData.dermatitisAlergicaContacto : false;
		examFormData.eccema = examFormData.eccema ? examFormData.eccema : false;
		examFormData.otros = examFormData.otros ? examFormData.otros : false;
		examFormData.medicoFirmaB64 = this.medicoFirmaB64;
		examFormData.medicoFirmaSigString = this.medicoFirmaSigString;

		examFormData = this.evaluateChangeTrabajador(examFormData);

		return examFormData;
	}

	private evaluateChangeTrabajador(object) {
		if (this.examen.seModificoTrabajador 
			|| this.examen.trabajador.fechaNacimiento != moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			|| this.examen.trabajador.apellidoNombre != this.examForm.controls.apellidoNombre.value) {

			object.trabajador = {
				apellidoNombre: this.examForm.controls.apellidoNombre.value,
				fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			};
			this.examen.seModificoTrabajador = true;
		}
		return object;
	}

	print(): void {
		window.print();
	}

	capitalize(word: string): string {
		if (!word) {
			return word;
		}
		return word[0].toUpperCase() + word.substr(1).toLowerCase();
	}

	/**
	 * función que recibe el trigger desde el componente attach-upload-file
	 * con el objeto actualizado de la lista de archivos y errores
	 * @param  {object} event
	 * @example:
	 *  {
	 *    errors: {
	 *      isSizeValid: false
	 *      isTypeValid: false,
	 *    },
	 *    data: [
	 *       {
	 *        archivoBase64: todounstringpegado,
	 *        nombreOriginal: "example.png",
	 *        tipo: "png",
	 *        size: 121354,
	 *        esAlta:false,
	 *        esBaja:false
	 *    ],
	 *    invalid: false,
	 *    isEmpty: true,
	 *    attachedFilesValidQuantity: 0
	 *  }
	 */
	getAttachedFiles(event: any): any {
		const { errors } = event;

		this.attachedFiles = event;
		if (errors.isSizeValid && errors.isTypeValid) {
			// asigno la data al objeto para enviar
			return false;
		}
	}

	private calculateAge(): void {
		let edad = null;
		if (this.examForm.controls.fechaNacimiento.value) {
			edad = moment().diff(
				moment(this.examForm.controls.fechaNacimiento.value),
				'years'
			);
		}
		this.examen.trabajador.edad = edad;
	}

	restrictDateIngresoEmpresa(): void {
		if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
		  this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
		} else {
		  this.maxDateIngreso = this.maxDate;
		}
	  }

	private navigateInvalidField(classFocus: string): void {
		const invalidFields = [].slice.call(
			document.getElementsByClassName(classFocus)
		);
		const field = invalidFields[1];
		field.scrollIntoViewIfNeeded();
		field.focus();
	}

	private saveToOnline(): void {
		this.groupDTemplateService
			.loadExam(this.buildRequest(), this.configForm.baseUrl)
			.subscribe(
				(response) => {
					this.databaseService.deleteItemFromTable(this.examen.id,
						`examenes${(this.examen.categoriaExamen === 'periodicos'
							? 'Periodicos'
							: 'Reevaluacion')}`);
					this.databaseService.deleteItemFromTable(this.examen.id,
						`examenes${(this.examen.categoriaExamen === 'periodicos'
							? 'PeriodicosFiltrados'
							: 'ReevaluacionFiltrados')}`);
					this.messageAlertServices.setMessage(0, {
						severity: 'success',
						summary: '',
						detail: response.message,
						key: 'examen',
					});
					setTimeout(() => {
						this.returnToExams();
					}, 500);
					this.enviandose = false;
				},
				(error) => {
					this.formatResponseAndOpenError(error);
				}
			);
	}

	private saveToOffline(): void {
		const dataToSend = this.buildRequest();
		dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
		dataToSend.cargadoOffline = true;
		const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';

		this.databaseService
			.setExameneOnExamenesPorEnviarTable(
				this.examen,
				dataToSend,
				false,
				this.examen.categoriaExamen === 'periodicos'
					? 'Periodicos'
					: 'Reevaluacion',
				this.buildUrlApi(this.configForm.baseUrl)
			)
			.then((response) => {
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'Periodicos'
						: 'Reevaluacion')}`);
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'PeriodicosFiltrados'
						: 'ReevaluacionFiltrados')}`);
				this.backgroundSyncService.registerEvent('save-examen');
				this.messageAlertServices.setMessage(0, {
					severity: 'success',
					summary: '',
					detail: details,
					key: 'examen',
				});
				setTimeout(() => {
					this.returnToExams();
				}, 500);
			})
			.catch((e) => {
				this.messageAlertServices.setMessage(0, {
					severity: 'error',
					summary: '',
					detail:
						'Ha ocurrido un error. Por favor reinitente más tarde y disculpe las molestias ocasionadas',
					key: 'examen',
				});
			});
	}

	formatResponseAndOpenError(error) {
		let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.openErrorAlert(message, 'examen');
	}

	private openErrorAlert(message: string, key: string): void {
		this.messageAlertServices.setMessage(0, {
			severity: 'error',
			summary: '',
			detail: message,
			key: key,
		});
		setTimeout(() => {
			const header = document.querySelector('#templateContainer') as any;
			window.scroll(0, header.offsetTop - 150);
		}, 100);
		this.enviandose = false;
	}

	setValuesOnFormOnViewAndEditMode() {
		this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);
		this.examen.codigoDictamen = this.examen.tipoDictamen ? this.examen.tipoDictamen : this.examen.codigoDictamen;
		this.examForm.controls.codigoDictamen.setValue(this.examen.codigoDictamen);
		this.examForm.controls.medicoEspecialidad.setValue(this.examen.medicoEspecialidad);
		this.examForm.controls.medicoMatricula.setValue(this.examen.medicoMatricula);
		this.examForm.controls.medicoNombre.setValue(this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));
		this.examForm.controls.expAntDesc?.setValue(this.examen.expAntDesc ? this.examen.expAntDesc : '');
		this.examForm.controls.riesgo?.setValue(this.examen.riesgo ? this.examen.riesgo : '');
		this.examForm.controls.sustTrab?.setValue(this.examen.sustTrab ? this.examen.sustTrab : '');
		this.examForm.controls.elemProtCual?.setValue(this.examen.elemProtCual ? this.examen.elemProtCual : '');
		this.examForm.controls.antEnfDerCual?.setValue(this.examen.antEnfDerCual ? this.examen.antEnfDerCual : '');
		this.examForm.controls.lesionLoc?.setValue(this.examen.lesionLoc ? this.examen.lesionLoc : '');
		this.examForm.controls.lesionExt?.setValue(this.examen.lesionExt ? this.examen.lesionExt : '');
		this.examForm.controls.lesionDesc?.setValue(this.examen.lesionDesc ? this.examen.lesionDesc : '');
		this.examForm.controls.restDesc?.setValue(this.examen.restDesc ? this.examen.restDesc : '');
		this.examForm.controls.otrosDesc?.setValue(this.examen.otrosDesc ? this.examen.otrosDesc : '');
		this.examForm.controls.conclusion?.setValue(this.examen.conclusion ? this.examen.conclusion : '');
		this.examen.expAnt ? this.clickCheckboxHabilitar(true, true, 'expAntDesc') : null;
		this.examen.elemProt ? this.clickCheckboxHabilitar(true, true, 'elemProtCual') : null;
		this.examen.antEnfDer ? this.clickCheckboxHabilitar(true, true, 'antEnfDerCual') : null;
		this.examen.lesion ? this.clickCheckboxHabilitar(true, true, 'lesionLoc') : null;
		this.examen.lesion ? this.clickCheckboxHabilitar(true, true, 'lesionExt') : null;
		this.examen.lesion ? this.clickCheckboxHabilitar(true, true, 'lesionDesc') : null;
		this.examen.otros ? this.clickCheckboxHabilitar(true, true, 'otrosDesc') : null;
		this.examen.restPat ? this.clickCheckboxHabilitar(true, true, 'restDesc') : null;
		this.invalidField = false;
	}

	clickCheckBox(valor, event) {
		switch (valor) {
			case 'expAntSi':
				this.examForm.controls.expAntNo.setValue(false);
				this.clickCheckboxHabilitar(event.checked, true, 'expAntDesc');
				break;
			case 'expAntNo':
				this.examForm.controls.expAntSi.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'expAntDesc');
				break;
			case 'elemProtSi':
				this.examForm.controls.elemProtNo.setValue(false);
				this.clickCheckboxHabilitar(event.checked, true, 'elemProtCual');
				break;
			case 'elemProtNo':
				this.examForm.controls.elemProtSi.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'elemProtCual');
				break;
			case 'antEnfDerSi':
				this.examForm.controls.antEnfDerNo.setValue(false);
				this.clickCheckboxHabilitar(event.checked, true, 'antEnfDerCual');
				break;
			case 'antEnfDerNo':
				this.examForm.controls.antEnfDerSi.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'antEnfDerCual');
				break;
			case 'lesionSi':
				this.examForm.controls.lesionNo.setValue(false);
				this.clickCheckboxHabilitar(event.checked, true, 'lesionLoc');
				this.clickCheckboxHabilitar(event.checked, true, 'lesionExt');
				this.clickCheckboxHabilitar(event.checked, true, 'lesionDesc');
				break;
			case 'lesionNo':
				this.examForm.controls.lesionSi.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'lesionLoc');
				this.clickCheckboxHabilitar(event.checked, false, 'lesionExt');
				this.clickCheckboxHabilitar(event.checked, false, 'lesionDesc');
				break;
			case 'restPat':
				this.examForm.controls.restNorm.setValue(false);
				this.clickCheckboxHabilitar(event.checked, true, 'restDesc');
				break;
			case 'restNorm':
				this.examForm.controls.restPat.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'restDesc');
				break;
			case 'otros':
				this.clickCheckboxHabilitar(event.checked, event.checked, 'otrosDesc');
				this.examForm.controls.diagnosticoNormal.setValue(false);
				break;
			case 'diagnosticoNormal':
				this.examForm.controls.otros.setValue(false);
				this.examForm.controls.dermatitisIrritativaContacto.setValue(false);
				this.examForm.controls.dermatitisAlergicaContacto.setValue(false);
				this.examForm.controls.eccema.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'otrosDesc');
				this.validateCheckboxItems();
				break;
			case 'dermatitisIrritativaContacto':
				this.examForm.controls.diagnosticoNormal.setValue(false);
				this.validateCheckboxItems();
				break;
			case 'dermatitisAlergicaContacto':
				this.examForm.controls.diagnosticoNormal.setValue(false);
				this.validateCheckboxItems();
				break;
			case 'eccema':
				this.examForm.controls.diagnosticoNormal.setValue(false);
				this.validateCheckboxItems();
				break;
		}
	}

	clickCheckboxHabilitar(checked, value, field): void {
		this.validateCheckboxItems();
		if (!value || !checked) {
			this.examForm.controls[field].disable();
			this.examForm.controls[field].setValue('');
			this.examForm.controls[field].setValidators(null);
		} else {
			this.examForm.controls[field].enable();
			switch (field) {
				case 'lesionDesc':
					this.examForm.controls[field].setValidators([
						Validators.required,
						Validators.maxLength(1000),
					]);
					break;
				default:
					this.examForm.controls[field].setValidators([
						Validators.required,
						Validators.maxLength(250),
					]);
					break;
			}
		}
		this.examForm.controls[field].updateValueAndValidity();
	}

	validateCheckboxItems(): void {
		if ((!this.examForm.controls.expAntNo.value && !this.examForm.controls.expAntSi.value)
			|| (!this.examForm.controls.elemProtNo.value && !this.examForm.controls.elemProtSi.value)
			|| (!this.examForm.controls.antEnfDerNo.value && !this.examForm.controls.antEnfDerSi.value)
			|| (!this.examForm.controls.lesionNo.value && !this.examForm.controls.lesionSi.value)
			|| (!this.examForm.controls.restNorm.value && !this.examForm.controls.restPat.value)
			|| (!this.examForm.controls.diagnosticoNormal.value && !this.examForm.controls.otros.value && !this.examForm.controls.dermatitisIrritativaContacto.value && !this.examForm.controls.dermatitisAlergicaContacto.value && !this.examForm.controls.eccema.value)) {
			this.invalidField = true;
		} else {
			this.invalidField = false;
		}
	}

	showModalFirma() {
		this.displayModalFirma = true;
	}

	closeModalFirma() {
		this.displayModalFirma = false;
	}

	recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
		this.medicoFirmaB64 = datos.firmaB64;
		this.medicoFirmaSigString = datos.firmaSigString;
	}

	deshabilitarApellidoNombreTrabajador() {
		return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
	}
}
